// extracted by mini-css-extract-plugin
export var pageContainer = "_q-1";
export var settingsContent = "_q-0";